<!-- Resource actions button -->
@if ( resourceTableService.actions.menuActions &&
resourceTableService.actions.menuActions.length !== 0 ) { @if (type ===
'primary') {
<button
  ctx-button--primary
  [disabled]="isActionsMenuEmpty(resource)"
  navIcon="ACTION_MENU"
  [matMenuTriggerFor]="actionsMatMenu"
>
  Actions
</button>
} @else {
<button
  ctx-button--secondary
  size="sm"
  [disabled]="isActionsMenuEmpty(resource)"
  actionIcon="ACTION_MENU"
  color="accent"
  [matMenuTriggerFor]="actionsMatMenu"
></button>
}
<mat-menu #actionsMatMenu="matMenu">
  @for (menuAction of menuActions; track menuAction) {
  <button
    mat-menu-item
    [disabled]="menuAction.disabled ? menuAction.disabled(resource) : false"
    (click)="menuAction.callback(resource)"
  >
    <span class="flex flex-row items-center gap-2">
      <hlm-icon [name]="icon(menuAction, resource)" inline></hlm-icon>
      <span>
        {{
          menuAction.labelCallback
            ? menuAction.labelCallback(resource)
            : menuAction.label
        }}
      </span>
    </span>
  </button>
  }
</mat-menu>
}
